import React, { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { useLang } from "@/i18n";
import { Navbar } from "./Navbar";
import { Footer } from "./Footer";

export default function MarketingLayout() {
  const { pathname } = useLocation();
  const { lang, setLang } = useLang();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  useEffect(() => {
    if (!localStorage.getItem("lang") && lang !== "en") setLang("en", false);
  }, [lang, setLang]);
  return (
    <div className="mk-root min-h-screen bg-mk-bg font-body text-white antialiased" onCopy={(e) => e.preventDefault()} onContextMenu={(e) => e.preventDefault()} data-testid="marketing-layout">
      <Navbar />
      <main><Outlet /></main>
      <Footer />
    </div>
  );
}
